var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.205,
    height: 20.205,
    viewBox: "0 0 16.205 20.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#6868bf}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_group_24px",
    d: "M9.1 11.945a3.472 3.472 0 1 0-3.47-3.473 3.458 3.458 0 0 0 3.47 3.473zm0 2.315c-2.7 0-8.1 1.354-8.1 4.051V25.2h16.2v-6.889c0-2.697-5.4-4.051-8.1-4.051z",
    className: "cls-1",
    transform: "translate(-1 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRc);
export default __webpack_public_path__ + "static/media/icon_rc.f9c6636f58c005209109548e24af7227.svg";
export { ForwardRef as ReactComponent };